import { lazy } from 'react';
import i18next from 'i18next';
import permissions from '@shared/config/permissions';
import { AllergiEndDocsIcon } from '@shared/ui/icons';

const AllergiEndResources = lazy(() =>
  import('../../../../../pages/allergi-end-resources')
);

const ALLERGI_END_RESOURCES_DASHBOARD = {
  path: '/:currentAccountUuid/allergi-end-resources',
  exact: true,
  additional: {
    component: AllergiEndResources,
    protected: true,
    title: i18next.t('titles:allergiEndResources'),
    icon: AllergiEndDocsIcon,
    permission: permissions.ACCOUNT_GET_ALLERGIEND_RESOURCES,
    breadcrumb: {
      isRoot: true,
      label: ({ state }) => state.i18n?.en?.titles?.allergiEndResources || 'Allergi end resources',
    },
  },
};
export const ALLERGI_END_RESOURCES_ROUTES = {
  // ------- For child accounts ------
  // ...

  // ------- For current accounts ------
  dashboard: ALLERGI_END_RESOURCES_DASHBOARD,
};
